import PropTypes from "prop-types";
import ToolTip from "../ToolTip";
import Logo from "../Logo";
import UpgradeAvailable from "../UpgradeAvailable";

export default function SubscriptionCard({ subscription, user, hasUpgrade }) {

  let subscriptionColour = "";
  if(subscription?.name === "Bronze"){
    subscriptionColour = "#AD8A56";
  } else if(subscription?.name === "Silver") {
    subscriptionColour = "#B4B4B4";
  } else if(subscription?.name === "Gold") {
    subscriptionColour = "#C9B037";
  }

  let upgradeEligible = true;

  if ((user.subscription.Name === "Gold" && (subscription?.name === "Bronze" || subscription?.name === "Silver")) ||
      (user.subscription.Name === "Silver" && subscription?.name === "Bronze") ||
      (user.subscription.Name === "Bronze" && (subscription?.name === "Silver" || subscription?.name === "Gold"))) {
    upgradeEligible = false;
  }

  return (
    <div
      style={{ borderColor: subscriptionColour }}
      className="min-h-[584px] min-w-[300px] flex flex-col gap-y-[22px] bg-white border-[2px] border-solid rounded-[4px] py-10 px-5"
    >
      <div className="flex gap-5 items-center">
        <Logo fill={subscriptionColour} size="icon" />

        <div className="flex flex-col">
          <p
            style={{ color: subscriptionColour }}
            className="capitalize font-semibold text-[26px] leading-[34px]"
          >
            {subscription.name}
          </p>
          <p className="capitalize font-semibold text-base leading-[26px]">
            {subscription.name === 'Bronze' ? 'Free' : `£${subscription.price}/Year`}
          </p>
        </div>
      </div>

      <div className="">
        <p className="text-base leading-[26px] text-[#727272]">
          {subscription.pwaHeading}
        </p>
      </div>

      <div className="">
        <ul className="list-disc pl-5">
          {subscription.pwaBulletPoints.map((item, index) => {
            return (
              <li
                className="text-base leading-[26px] text-[#101820] font-medium"
                key={index}
              >
                <p className="">
                  {item.text}
                  {item.tooltip && <ToolTip text={item.tooltip} />}
                </p>
              </li>
            );
          })}
        </ul>
      </div>

      <div className="mt-auto">
        {(subscription.name === user.subscription.Name && !hasUpgrade) ? (
          <div className="w-full p-[12px] bg-sportsLightGrey rounded-[4px]">
           <p className="text-sportsDarkGrey font-semibold text-center">Current Plan</p>
          </div>
        ) : (
          hasUpgrade ? (
            <UpgradeAvailable />
          ) : (
            <div className="w-full p-[12px] bg-sportsLightGrey rounded-[4px]">
              <p className="text-sportsDarkGrey font-semibold text-center">Unavailable</p>
            </div>
          )
        )}
      </div>
    </div>
  );
}

SubscriptionCard.propTypes = {
  subscription: PropTypes.shape({
    user: PropTypes.object,
    colour: PropTypes.string,
    name: PropTypes.string.isRequired,
    price: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    includes: PropTypes.arrayOf(
      PropTypes.shape({
        text: PropTypes.string.isRequired,
        tooltip: PropTypes.string,
      })
    ).isRequired,
  }).isRequired,
};